/**
 * Based on https://medium.com/angular-in-depth/building-tooltips-for-angular-3cdaac16d138
 */
import { Overlay, OverlayPositionBuilder, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ComponentRef, Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { ActionTooltipComponent } from './action-tooltip.component';

@Directive({ selector: '[actionTooltip]' })
export class ActionTooltipDirective implements OnChanges, OnDestroy {
  @Input('actionTooltipShow') show = false;
  @Input('actionTooltip') text = '';
  @Input('actionTooltipButtonText') buttonText = '';
  @Input('actionTooltipButtonCallback') callback = () => {};

  overlayRef: OverlayRef;

  constructor(
    private overlay: Overlay,
    private overlayPositionBuilder: OverlayPositionBuilder,
    private elementRef: ElementRef) {
    const positionStrategy = this.overlayPositionBuilder
      .flexibleConnectedTo(this.elementRef)
      .withPositions([
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom'
        }
      ])
      .withDefaultOffsetX(-40)
      .withDefaultOffsetY(-30);

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    this.overlayRef = this.overlay.create({
      positionStrategy: positionStrategy,
      scrollStrategy: scrollStrategy,
      disposeOnNavigation: true
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['show']) {
      if (changes['show'].currentValue === true) {
        setTimeout(() => {
          this.attachComponent();
          this.overlayRef.updatePosition();
        }, 100);
      } else {
        this.detachComponent();
      }
    }
  }

  ngOnDestroy() {
    this.detachComponent();
  }

  private attachComponent() {
    const tooltipRef: ComponentRef<ActionTooltipComponent> = this.overlayRef.attach(new ComponentPortal(ActionTooltipComponent));
    tooltipRef.instance.text = this.text;
    tooltipRef.instance.buttonText = this.buttonText;
    tooltipRef.instance.callback = this.callback;
  }

  private detachComponent() {
    this.overlayRef.detach();
  }
}
